<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="accountManagerName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="accountManagerDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioCode">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Cetip</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ticketCuttofTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Modalidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.ticketCuttofTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="currencyQuotation">
    <th mat-header-cell class="header" *matHeaderCellDef>Cotação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.currencyQuotation | currency: "R$":"symbol":"1.0-6" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="parityPl">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Paridade de Avaliação PL
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.parityPl }}
    </td>
  </ng-container>

  <ng-container matColumnDef="parityMtm">
    <th mat-header-cell class="header" *matHeaderCellDef>Paridade MTM</th>
    <td mat-cell *matCellDef="let element">
      {{ element.parityMtm }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="tradingPlace">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Praça de Negociação
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.tradingPlace }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementPlace">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Praça de Liquidação
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementPlace }}
    </td>
  </ng-container>

  <ng-container matColumnDef="appealDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data do Recurso</th>
    <td mat-cell *matCellDef="let element">
      {{ element.appealDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="contractSaleSettlementDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.contractSaleSettlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="currencyAmount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Quantidade de Moeda
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.currencyAmount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsExchange.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsExchange"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsExchange"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
